import { SvgIcon, SvgIconProps } from '@mui/material';

export function MenuIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_989_35710)">
          <g clipPath="url(#clip1_989_35710)">
            <path
              d="M12 26H28C28.55 26 29 25.55 29 25C29 24.45 28.55 24 28 24H12C11.45 24 11 24.45 11 25C11 25.55 11.45 26 12 26ZM12 21H28C28.55 21 29 20.55 29 20C29 19.45 28.55 19 28 19H12C11.45 19 11 19.45 11 20C11 20.55 11.45 21 12 21ZM11 15C11 15.55 11.45 16 12 16H28C28.55 16 29 15.55 29 15C29 14.45 28.55 14 28 14H12C11.45 14 11 14.45 11 15Z"
              fill="currentcolor"
            />
          </g>
        </g>
        <defs>
          <clipPath id="clip0_989_35710">
            <rect
              width="24"
              height="24"
              fill="currentcolor"
              transform="translate(8 8)"
            />
          </clipPath>
          <clipPath id="clip1_989_35710">
            <rect
              width="24"
              height="24"
              fill="currentcolor"
              transform="translate(8 8)"
            />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  );
}
